import React from 'react';
import { Typography, Card, Row, Col, Button } from 'antd';
import { Link } from 'react-router-dom';
import { 
  PictureOutlined, 
  ToolOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Home: React.FC = () => {
  const tools = [
    {
      title: '图片处理工具',
      description: '调整图片分辨率、裁剪图片、转换格式并压缩图片大小',
      icon: <PictureOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      link: '/image-processor'
    },
    {
      title: '更多工具',
      description: '敬请期待更多实用工具...',
      icon: <ToolOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
      link: '/placeholder'
    }
  ];

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <Title>在线工具集</Title>
        <Paragraph style={{ fontSize: '16px', color: 'rgba(0,0,0,0.65)' }}>
          简单、高效、免费的在线工具，无需安装，随时随地使用
        </Paragraph>
      </div>

      <Row gutter={[24, 24]} justify="center">
        {tools.map((tool, index) => (
          <Col xs={24} sm={12} md={8} key={index}>
            <Card 
              hoverable 
              style={{ height: '100%' }}
              bodyStyle={{ 
                display: 'flex', 
                flexDirection: 'column',
                height: '100%'
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                {tool.icon}
              </div>
              <Title level={4} style={{ textAlign: 'center' }}>{tool.title}</Title>
              <Paragraph style={{ 
                textAlign: 'center',
                color: 'rgba(0,0,0,0.45)',
                flex: 1
              }}>
                {tool.description}
              </Paragraph>
              <Link to={tool.link}>
                <Button 
                  type="primary" 
                  block
                  style={{ marginTop: '20px' }}
                >
                  立即使用 <ArrowRightOutlined />
                </Button>
              </Link>
            </Card>
          </Col>
        ))}
      </Row>

      <div style={{ 
        marginTop: '60px', 
        textAlign: 'center',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        borderRadius: '4px'
      }}>
        <Title level={4}>关于本站</Title>
        <Paragraph style={{ maxWidth: '600px', margin: '0 auto' }}>
          本站提供各种实用的在线工具，完全免费，无需注册。所有工具均在浏览器中运行，不会上传您的数据到服务器，保护您的隐私。
        </Paragraph>
      </div>
    </div>
  );
};

export default Home;